import { STATUS_VARIANTS } from '../constants/common';
import { SERVICE_STATUS_VARIANTS } from '../constants/service';
import { FILE_STATUS_VARIANTS } from '../constants/file';
import { USER_STATUS_VARIANTS } from '../constants/user';
import { CAR_STATUS_VARIANTS } from '../constants/car';

export const normalizeCarStatus = (car) => {
  if (car?.status) return car.status;
  if (car?.verified === true) return CAR_STATUS_VARIANTS.active;
  if (car?.verified === false) return CAR_STATUS_VARIANTS.pending;
  return CAR_STATUS_VARIANTS.active;
};

export const normalizeUserStatus = (user) => {
  if (user?.status) return user.status;
  if (user?.verified === true) return USER_STATUS_VARIANTS.active;
  if (user?.verified === false) return USER_STATUS_VARIANTS.pending;
  return USER_STATUS_VARIANTS.pending;
};

export const getCarStatusLabel = (status) => {
  switch (status) {
    case CAR_STATUS_VARIANTS.pending:
      return 'EN COURS';
    case CAR_STATUS_VARIANTS.active:
      return 'ACTIF';
    case CAR_STATUS_VARIANTS.inactive:
      return 'INACTIF';
    case CAR_STATUS_VARIANTS.rejected:
      return 'REFUSÉ';
    default:
      return '';
  }
};

export const getUserStatusLabel = (status) => {
  switch (status) {
    case USER_STATUS_VARIANTS.pending:
      return 'EN COURS';
    case USER_STATUS_VARIANTS.active:
      return 'ACTIF';
    case USER_STATUS_VARIANTS.archived:
      return 'ARCHIVÉ';
    case USER_STATUS_VARIANTS.inactive:
      return 'INACTIF';
    case USER_STATUS_VARIANTS.rejected:
      return 'REFUSÉ';
    default:
      return '';
  }
};

export const getFileStatusLabel = (status) => {
  switch (status) {
    case FILE_STATUS_VARIANTS.PENDING:
      return 'EN COURS';
    case FILE_STATUS_VARIANTS.VERIFIED:
      return 'VALIDÉ';
    case FILE_STATUS_VARIANTS.EXPIRED:
      return 'EXPIRÉ';
    case FILE_STATUS_VARIANTS.REJECTED:
      return 'REFUSÉ';
    default:
      return '';
  }
};

export const getStatusConfigs = (status, isDarkMode) => {
  switch (status) {
    case STATUS_VARIANTS.completed:
    case SERVICE_STATUS_VARIANTS.verified:
    case FILE_STATUS_VARIANTS.VERIFIED:
      return {
        badgeBackground: isDarkMode ? '#1A352D' : '#CEEAE2',
        badgeBorder: isDarkMode ? '#2D5448' : '#99C2B5',
        textColor: isDarkMode ? '#69EDD7' : '#03A26F',
        label: 'VALIDÉ',
      };
    case STATUS_VARIANTS.pending:
    case FILE_STATUS_VARIANTS.PENDING:
    case USER_STATUS_VARIANTS.pending:
    case CAR_STATUS_VARIANTS.pending:
      return {
        badgeBackground: isDarkMode ? '#5B5843' : '#FFFCEC',
        badgeBorder: isDarkMode ? '#898358' : '#DDD8B5',
        textColor: isDarkMode ? '#EDDC69' : '#C1A700',
        label: 'EN COURS',
      };
    case USER_STATUS_VARIANTS.active:
    case CAR_STATUS_VARIANTS.active:
      return {
        badgeBackground: isDarkMode ? '#1A352D' : '#CEEAE2',
        badgeBorder: isDarkMode ? '#2D5448' : '#99C2B5',
        textColor: isDarkMode ? '#69EDD7' : '#03A26F',
        label: 'ACTIF',
      };
    case USER_STATUS_VARIANTS.archived:
      return {
        badgeBackground: isDarkMode ? '#3A3A3A' : '#EDEDED',
        badgeBorder: isDarkMode ? '#5A5A5A' : '#C8C8C8',
        textColor: isDarkMode ? '#ACACAC' : '#6E6E6E',
        label: 'ARCHIVÉ',
      };
    case USER_STATUS_VARIANTS.inactive:
    case CAR_STATUS_VARIANTS.inactive:
      return {
        badgeBackground: isDarkMode ? '#303030' : '#EDEDED',
        badgeBorder: isDarkMode ? '#ACACAC' : '#C8C8C8',
        textColor: isDarkMode ? '#ACACAC' : '#6E6E6E',
        label: 'INACTIF',
      };
    case STATUS_VARIANTS.rejected:
    case FILE_STATUS_VARIANTS.REJECTED:
    case USER_STATUS_VARIANTS.rejected:
    case CAR_STATUS_VARIANTS.rejected:
      return {
        badgeBackground: isDarkMode ? '#461F1F' : '#FDE6E7',
        badgeBorder: isDarkMode ? '#6B3434' : '#FBC7C7',
        textColor: '#FF6669',
        label: 'REFUSÉ',
      };
    case FILE_STATUS_VARIANTS.EXPIRED:
      return {
        badgeBackground: isDarkMode ? '#461F1F' : '#FDE6E7',
        badgeBorder: isDarkMode ? '#6B3434' : '#FBC7C7',
        textColor: '#FF6669',
        label: 'EXPIRÉ',
      };

    default:
      return {};
  }
};
